export type SkeletonVariant = 'text' | 'card' | 'table-row' | 'circle' | 'rect';

export interface SkeletonProps {
  readonly variant?: SkeletonVariant;
  /** When `variant="text"`, number of lines to render (defaults 3). */
  readonly lines?: number;
  /** Custom width (CSS value). Overrides default for the chosen variant. */
  readonly width?: string;
  /** Custom height (CSS value). Overrides default for the chosen variant. */
  readonly height?: string;
  readonly className?: string;
}

const TEXT_LINE_WIDTHS = ['100%', '80%', '60%', '90%', '70%'];

/**
 * Loading placeholder. Mirrors HTHD admin Skeleton's variants — text,
 * card, table-row, circle — and adds a generic `rect` variant for
 * arbitrary placeholders.
 */
export function Skeleton({
  variant = 'text',
  lines = 3,
  width,
  height,
  className = '',
}: SkeletonProps): JSX.Element {
  const baseCls = `ferro-skeleton ferro-skeleton--${variant}`;
  const cls = `${baseCls}${className ? ` ${className}` : ''}`;
  const inlineStyle = width || height ? { width, height } : undefined;

  if (variant === 'text') {
    return (
      <div className={`ferro-skeleton-stack${className ? ` ${className}` : ''}`}>
        {Array.from({ length: lines }, (_, i) => (
          <div
            key={i}
            className="ferro-skeleton ferro-skeleton--text"
            style={{ width: TEXT_LINE_WIDTHS[i % TEXT_LINE_WIDTHS.length] }}
          />
        ))}
      </div>
    );
  }

  return <div className={cls} style={inlineStyle} aria-busy="true" />;
}
